import React from "react";
import { Link } from "react-router-dom";
import { hubs } from "../data/mock";
import { JoinBand, Reveal, Kick, Faq } from "../components/Shared";
import Seo, { breadcrumbSchema, faqSchema } from "../components/Seo";

export default function Hub({ hubKey }) {
  const hub = hubs[hubKey];

  return (
    <>
      <Seo
        title={hub.metaTitle}
        description={hub.metaDescription}
        path={hub.path}
        schemas={[
          faqSchema(hub.faq),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: hub.name, path: hub.path },
          ]),
        ]}
      />
      <header className="hub-hero">
        <span className="bigkanji" aria-hidden="true">{hub.seal}</span>
        <div className="wrap">
          <div className="crumbs">
            <Link to="/">Home</Link>
            <span className="sep">/</span>
            <span className="cur">{hub.name}</span>
          </div>
          <Kick k={hub.seal}>{hub.kicker}</Kick>
          <h1>
            {hub.h1[0]} <span className="ol">{hub.h1[1]}</span>
          </h1>
          <p className="lede">{hub.sub}</p>
        </div>
      </header>

      <section style={{ paddingBottom: 64 }}>
        <div className="wrap">
          <Reveal className="answer">
            <h2>{hub.answer.q}</h2>
            <p>{hub.answer.a}</p>
          </Reveal>
        </div>
      </section>

      <section style={{ paddingTop: 0 }}>
        <div className="wrap">
          <Reveal>
            <Kick k="道">The Tenets</Kick>
            <h2 className="sec">Five rules. No exceptions.</h2>
          </Reveal>
          <div className="tenets" style={{ marginTop: 40 }}>
            {hub.tenets.map((t, i) => (
              <Reveal key={t.title} className="tenet" delay={i < 3 ? `d${i + 1}` : ""}>
                <p className="tnum">0{i + 1}</p>
                <h3>{t.title}</h3>
                <p>{t.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="quoteband">
        <div className="wrap">
          <Reveal>
            <blockquote>
              {hub.quote.text}
              <span className="attr">{hub.quote.attr}</span>
            </blockquote>
          </Reveal>
        </div>
      </section>

      <section>
        <div className="wrap">
          <Reveal>
            <Kick k="巻">The Scrolls</Kick>
            <h2 className="sec">Read the dispatches.</h2>
          </Reveal>
          <div className="grid3" style={{ marginTop: 40 }}>
            {hub.articles.map((a, i) =>
              a.available ? (
                <Reveal key={a.slug} delay={`d${(i % 3) + 1}`}>
                  <Link className="acard islink" to={a.href} style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <div className="amedia">
                      <span className="abadge">{hub.name}</span>
                      <img src={a.image} alt={a.alt} loading="lazy" />
                    </div>
                    <div className="abody">
                      <h3>{a.title}</h3>
                      <p>{a.excerpt}</p>
                      <span className="ameta">{a.readTime}</span>
                    </div>
                  </Link>
                </Reveal>
              ) : (
                <Reveal key={a.slug} className="acard" delay={`d${(i % 3) + 1}`}>
                  <div className="amedia">
                    <span className="abadge soon">Coming Soon</span>
                    {a.image ? (
                      <img src={a.image} alt={a.alt} loading="lazy" style={{ opacity: 0.75 }} />
                    ) : (
                      <div className="akanji" aria-hidden="true">{a.kanji}</div>
                    )}
                  </div>
                  <div className="abody">
                    <h3>{a.title}</h3>
                    <p>{a.excerpt}</p>
                    <span className="ameta">{a.readTime}</span>
                  </div>
                </Reveal>
              )
            )}
          </div>
        </div>
      </section>

      <section style={{ paddingTop: 0 }}>
        <div className="wrap">
          <Reveal className="labbox">
            <div>
              <p className="lb-tag">The Lab</p>
              <p>{hub.lab}</p>
            </div>
            <a className="btn wh" href="https://ninjathlete.com" rel="noopener noreferrer" target="_blank">
              Visit NinjAthlete
            </a>
          </Reveal>
          {hub.road && (
            <Reveal className="labbox" delay="d1" style={{ marginTop: 22 }}>
              <div>
                <p className="lb-tag">The Road</p>
                <p>{hub.road}</p>
              </div>
              <a className="btn ol" href="https://ninjarunclub.com" rel="noopener noreferrer" target="_blank">
                Visit NinjaRunClub
              </a>
            </Reveal>
          )}
        </div>
      </section>

      <section style={{ paddingTop: 0 }}>
        <div className="wrap">
          <Reveal>
            <Kick k="問">Questions</Kick>
            <h2 className="sec">Asked and answered.</h2>
          </Reveal>
          <div style={{ marginTop: 30 }}>
            <Faq items={hub.faq} />
          </div>
        </div>
      </section>

      <JoinBand />
    </>
  );
}
